<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <modal size="large"
         v-show="isShowModal"
         id="ModalMarketPlace">

    <template v-slot:header>
      <h3 class="title" :class="entity.is_seller ? 'seller' : 'buyer'">Market Place {{ customerType }}</h3>
    </template>

    <template v-slot:body>
      <div class="container">
        <div class="form-row">
          <div class="col-6 col-sm-2 form-group">
            <label for="marketPlaceProduct" class="required">Produto</label>
            <select id="marketPlaceProduct"
                    :class="{'is-invalid': errors['product_id']}"
                    required
                    class="form-control form-control-sm"
                    v-model="entity.product_id">
              <optgroup v-for="c in categories" :label="c.name">
                <option v-for="p in products"
                        v-if="p.product_category_id === c.id"
                        :key="p.id"
                        :value="p.id">{{ p.name }}
                </option>
              </optgroup>
            </select>
            <field-messages :errors="errors.product_id"/>
          </div>
          <div class="col-6 col-sm-3 form-group">
            <label class="required">Tipo cliente</label>
            <div class="checkbox-inline" style="padding: 5px">
              <label>
                <input type="checkbox"
                       v-model="entity.is_seller"
                       v-if="!entity.id"
                       class="checkbox seller m"/>
                &nbsp;
                <transition name="tab" mode="out-in">
                  <span v-if="entity.is_seller" key="seller"
                        class="label-seller f-w-700 t-t-u">{{ customerType }}</span>
                  <span v-else key="buyer" class="label-buyer f-w-700 t-t-u">{{ customerType }}</span>
                </transition>
              </label>
            </div>
          </div>
          <div class="col-4 col-sm-4 form-group">
            <label for="marketPlaceCustomer" class="required">{{ customerType }}</label>
            <Autocomplete id="marketPlaceCustomer"
                          v-model="customer_name"
                          :placeholder="`Informe o nome do ${customerType}`"
                          url="/v1/market_places/search/customers?criteria="
                          :input-class="['form-control form-control-sm', {'is-invalid': errors.customer_id}]"
                          :on-select-item="returnValue"
                          :item-value-presentation="itemValuePresentation"
                          :item-presentation="itemPresentation"/>
            <field-messages :errors="errors.customer_id"/>
          </div>
          <div class="col-2 col-sm-3 form-group">
            <label for="marketPlaceBroker" class="required">Corretor</label>
            <select id="marketPlaceBroker"
                    required
                    :class="{'is-invalid': errors.broker}"
                    class="form-control form-control-sm"
                    v-model="entity.broker_id">
              <option v-for="b in filterBrokers"
                      :key="b.id"
                      :disabled="b.removed"
                      :value="b.id">{{ b.name }} {{ b.last_name }}
              </option>
            </select>
            <field-messages :errors="errors.broker"/>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-4 col-md-1">
            <label for="marketPlaceHarvest" class="required">Safra</label>
            <input type="number" id="marketPlaceHarvest" min="2017" required
                   :class="{'is-invalid': errors['harvest']}"
                   class="form-control form-control-sm"
                   v-model="entity.harvest"/>
            <field-messages :errors="errors.harvest"/>
          </div>
          <div class="col-4 form-group col-md-2">
            <label for="marketPlaceQtd" class="required">Quantidade</label>
            <input type="text"
                   id="marketPlaceQtd"
                   :class="{'is-invalid': errors.quantity}"
                   autocomplete="off"
                   v-money="{precision: 0, decimal: '', thousands: '.'}"
                   class="form-control form-control-sm t-r"
                   v-model="entity.quantity"/>
            <field-messages :errors="errors.quantity"/>
          </div>
          <div class="col-4 form-group col-md-2">
            <label for="marketPlaceEditPrice" class="required">Preço</label>
            <input type="text"
                   id="marketPlaceEditPrice"
                   :class="{'is-invalid': errors.price}"
                   autocomplete="off"
                   v-money="{precision: 2, decimal: ',', thousands: '.'}"
                   class="form-control form-control-sm t-r"
                   v-model="entity.price"/>
            <field-messages :errors="errors.price"/>
          </div>
          <div class="col-6 col-md-4 form-group">
            <label for="marketPlaceEditCity" class="required">Praça</label>
            <Autocomplete id="marketPlaceEditCity"
                          v-model="city_name"
                          placeholder="Informe a cidade"
                          url="/v1/location/search_cities?city_name="
                          :input-class="['form-control form-control-sm', {'is-invalid': errors.city_id}]"
                          :on-select-item="returnCity"
                          :item-value-presentation="cityValuePresentation"
                          :item-presentation="cityPresentation"/>
            <field-messages :errors="errors.city_id"/>
          </div>
          <div class="col-6 form-group col-md-1">
            <label for="marketPlaceFreightType" class="required">Mod</label>
            <select id="marketPlaceFreightType"
                    required
                    :class="{'is-invalid': errors.freight_type}"
                    class="form-control form-control-sm"
                    v-model="entity.freight_type">
              <option v-for="ft in freight_types"
                      :key="ft.code"
                      :value="ft.code">{{ ft.label }}
              </option>

            </select>
            <field-messages :errors="errors.freight_type"/>
          </div>
          <div class="col-6 form-group col-md-2">
            <label for="marketPlaceTaxType">Tributo</label>
            <select id="marketPlaceTaxType"
                    :class="{'is-invalid': errors.tax_type}"
                    class="form-control form-control-sm"
                    v-model="entity.tax_type">
              <option :value="null">[Selecione]</option>
              <option v-for="ft in tax_types"
                      :key="ft.code"
                      :value="ft.code">{{ ft.label }}
              </option>
            </select>
            <field-messages :errors="errors.tax_type"/>
          </div>
        </div>
        <div class="form-row">
          <div class="col-6 form-group col-md-3">
            <label for="marketPlaceShipmentLogStartAt" class="required">Data inicial</label>
            <div class="input-group input-group-sm">
              <input type="text"
                     id="marketPlaceShipmentLogStartAt"
                     required="true"
                     :class="{'is-invalid': errors.shipment_log_start_at}"
                     v-model="entity.shipment_log_start_at"
                     placeholder="DD/MM/AAAA"
                     v-flatpickr
                     v-mask="'##/##/####'"
                     class="form-control form-control-sm t-c plch-center n-m-r-right">
              <div class="input-group-append">
                <div class="input-group-text">
                  <svg-icon icon="calendar-alt"/>
                </div>
              </div>

              <field-messages :errors="errors.shipment_log_start_at"/>
            </div>
          </div>
          <div class="col-6 form-group col-md-3">
            <label for="marketPlaceShipmentLogEndAt">Data final</label>
            <div class="input-group input-group-sm">
              <input type="text"
                     id="marketPlaceShipmentLogEndAt"
                     required="false"
                     :class="{'is-invalid': errors.shipment_log_end_at}"
                     v-model="entity.shipment_log_end_at"
                     placeholder="DD/MM/AAAA"
                     v-flatpickr
                     v-mask="'##/##/####'"
                     class="form-control form-control-sm t-c plch-center n-m-r-right">
              <div class="input-group-append">
                <div class="input-group-text">
                  <svg-icon icon="calendar-alt"/>
                </div>
              </div>
              <field-messages :errors="errors.shipment_log_end_at"/>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-12">
            <label for="marketPlaceEditNotes">Observações</label>
            <textarea id="marketPlaceEditNotes"
                      :class="{'is-invalid': errors.notes}"
                      class="form-control form-control-sm"
                      placeholder="Informe observações pertinentes"
                      v-model="entity.notes"></textarea>
            <field-messages :errors="errors.notes"/>
          </div>
        </div>
        <div v-if="entity.id" class="form-row">
          <div class="form-group col-md-3">
            <label class="c-theme">Criado</label>
            <input type="text" readonly class="form-control-plaintext form-control-sm"
                   :title="entity.created_at | formatDate('DD/MM/YYYY HH:mm:ss')"
                   :value="entity.created_distance + ' atrás'">
          </div>
          <div class="form-group col-md-3" v-if="entity.user_create">
            <label class="c-theme">Quem criou</label>
            <input type="text" readonly class="form-control-plaintext form-control-sm" :value="entity.user_create.name">
          </div>
          <div class="form-group col-md-3" v-if="entity.user_update">
            <label class="c-theme">Última alteração</label>
            <input type="text" readonly class="form-control-plaintext form-control-sm"
                   :title="entity.updated_at | formatDate('DD/MM/YYYY HH:mm:ss')"
                   :value="entity.updated_distance + ' atrás'">
          </div>
          <div class="form-group col-md-3" v-if="entity.user_update">
            <label class="c-theme">Quem alterou</label>
            <input type="text" readonly class="form-control-plaintext form-control-sm" :value="entity.user_update.name">
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <button type="button"
              @click="reset"
              class="btn btn-sm btn-secondary">
        <svg-icon icon="sync"/>
        Limpar
      </button>
      <button type="button"
              @click="saveMarketPlace"
              class="btn btn-sm" :class="entity.is_seller ? 'btn-seller' : 'btn-buyer'">
        <svg-icon icon="save"/>
        Salvar
      </button>
      <button type="button"
              @click="isShowModal = false"
              class="btn btn-sm btn-dark">
        <svg-icon icon="times"/>
        Fechar
      </button>
    </template>
  </modal>
</template>

<script>
import {EventBus, SHOW_MARKET_PLACE} from "@/utils/EventBus";
import {createNamespacedHelpers} from 'vuex'
import Autocomplete from "../../components/particles/Autocomplete";
import dayjs from "dayjs";

const productsStore = createNamespacedHelpers('products');
const {mapActions} = createNamespacedHelpers('market_places');

const entityBase = {
  customer_id: null,
  city_id: null,
  product_id: 5, /*todo: POR ENQUANTO SÓ MILHO*/
  broker_id: 0,
  tax_type: null,
  shipment_log_start_at: null,
  shipment_log_end_at: null,
  harvest: new Date().getFullYear(),
  freight_type: 'cif',
  is_seller: true,
  quantity: null,
  price: null,
  taxes_incidence: null,
  shipment_log: 'jan',
  shipment_log_other: null
};

export default {
  name: "ModalMarketPlace",
  components: {Autocomplete},
  data() {
    return {
      isShowModal: false,
      errors: {},
      customer_name: null,
      city_name: null,
      freight_types: [],
      shipment_logs: [],
      tax_types: [],
      brokers: [],
      entity: {...entityBase}
    }
  },
  methods: {
    ...productsStore.mapActions(['loadAll', 'loadCategories']),
    ...mapActions(['save', 'load']),
    returnValue(obj) {
      this.entity.customer_id = obj.id;

      if (obj.city) {
        this.entity.city_id = obj.city.id;
        this.city_name = `${obj.city.name}/${obj.city.state.acronym}`
      }
    },
    itemPresentation(obj, val) {
      const regex = new RegExp(val, 'gi');
      const name = this.$appUtils.highlightText(obj.name, regex);
      const city_name = this.$appUtils.highlightText(obj.city.name, regex);
      const state_acronym = this.$appUtils.highlightText(obj.city.state.acronym, regex);

      let document = 'SEM DOCUMENTO';
      let doc_len = 0;

      if (obj.document) {
        document = this.$appUtils.highlightText(this.$appUtils.formatDocument(obj.document), regex);
        doc_len = obj.document.length;
      }

      return ['<div class="ellipsis">', name, '</div>', '<div style="font-size: .8em" class="ellipsis">', (doc_len === 14 ? 'CNPJ' : 'CPF'), ': ', document, ' | CIDADE: ', city_name, '/', state_acronym, '</div>'].join('');
    },
    itemValuePresentation: obj => obj.name,
    loadFreightTypes() {
      this.$appHttp.get('/v1/market_places/load_freight_types')
          .then(({data}) => this.freight_types = data)
          .catch(err => {
            this.$snotify.warning('Aconteceu algum problema ao tentar carregar os tipos de frete.', this.$appStorage.getUser().name);
            console.error('Load freight types error.', err);
          });
    },
    loadShipmentLogs() {
      this.$appHttp.get('/v1/market_places/load_shipment_logs')
          .then(({data}) => this.shipment_logs = data)
          .catch(err => {
            this.$snotify.warning('Aconteceu algum problema ao tentar carregar os logísticas.', this.$appStorage.getUser().name);
            console.error('Load freight types error.', err);
          });
    },
    loadTaxTypes() {
      this.$appHttp.get('/v1/market_places/load_tax_types')
          .then(({data}) => this.tax_types = data)
          .catch(err => {
            this.$snotify.warning('Aconteceu algum problema ao tentar carregar os tipos de tributos.', this.$appStorage.getUser().name);
            console.error('Load tax types error.', err);
          });
    },
    loadBrokers() {
      this.$appHttp.get('/v1/market_places/load_brokers')
          .then(({data}) => this.brokers = data)
          .catch(err => {
            this.$snotify.warning('Aconteceu algum problema ao tentar carregar os corretores.', this.$appStorage.getUser().name);
            console.error('Load brokers error.', err);
          });
    },
    returnCity(obj) {
      this.entity.city_id = obj.id
    },
    cityValuePresentation: obj => `${obj.name}/${obj.state.acronym}`,
    cityPresentation(obj, val) {
      const regex = new RegExp(val, 'gi');
      const name = this.$appUtils.highlightText(obj.name, regex);

      return ['<div class="ellipsis">', name, '</div>', '<div>Estado: ', obj.state.name, '/', obj.state.acronym, '<div>'].join('');
    },
    saveMarketPlace() {
      this.errors = {};
      this.save(this.entity)
          .then(() => {
            this.$snotify.success(this.$t('common.dataSaveSuccess'), this.$appStorage.getUser().name);
            this.reset();
          })
          .catch(({response}) => {
            this.$appUtils.vibrate();
            if (response.status === 422) {
              Object.keys(response.data).forEach(k => {
                this.$set(this.errors, k, response.data[k]);
              });
              this.$snotify.warning('Verifique os dados informados', 'Validação');
            } else if (response.status === 403) {
              this.$snotify.warning('Você não possui permissão para executar essa ação', this.$appStorage.getUser().name)
            } else {
              this.$snotify.error(this.$t('commons.tryContactSupport', {msg: 'Ops... Aconteceu algum problema ao tentar salvar.'}), this.$appStorage.getUser().name);
            }
          })
    },
    reset() {
      this.entity = {...entityBase, shipment_log_start_at: dayjs().format('DD/MM/YYYY')};
      this.city_name = null;
      this.customer_name = null;
      this.errors = {};
    }
  },
  computed: {
    ...productsStore.mapGetters({products: 'all', categories: 'categories'}),
    customerType() {
      return this.entity.is_seller ? 'Vendedor' : 'Comprador'
    },
    filterBrokers() {
      let brokers = [...this.brokers].filter(b => !b.removed)
      const removed = this.brokers.find(b => b.removed && b.id === this.entity.broker_id);
      if (removed) brokers.push(removed)

      return brokers
    }
  },
  mounted() {
    EventBus.$on(SHOW_MARKET_PLACE, options => {

      this.reset();

      const e = options.entity || {};
      this.callbackModal = options.callback || function () {};

      this.loadFreightTypes();
      this.loadShipmentLogs();
      this.loadCategories();
      this.loadAll();
      this.loadTaxTypes();
      this.loadBrokers()

      if (e.id) {
        this.load(e.id)
            .then(data => {
              this.entity = {
                ...data,
                price: this.$appUtils.formatMoney(data.price),
                quantity: this.$appUtils.formatNumber(data.quantity, 0, '', '.'),
                shipment_log_start_at: this.$appUtils.formatDate(data.shipment_log_start_at),
                shipment_log_end_at: data.shipment_log_end_at ? this.$appUtils.formatDate(data.shipment_log_end_at) : null
              };
              this.customer_name = data.customer.name;

              if (data.city) this.city_name = `${data.city.name}/${data.city.state.acronym}`;

              this.isShowModal = true;
            })
            .catch(console.error)
      } else {
        this.isShowModal = true;
      }
    });
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/variables";

.title {
  transition: color .3s ease;

  &.seller {
    color: $market_place_seller;
  }

  &.buyer {
    color: $market_place_buyer;
  }
}

.label-seller {
  color: $market_place_seller;
}

.label-buyer {
  color: $market_place_buyer;
}
</style>
